import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { fetchBusinessRules } from '../../../../services/dtServices'
import { GetBusinessRulesResponse } from '../../../../services/apiInterfaces'

export const useGetRuleSets = (
    orgId: string,
    entityId: string,
    reload: boolean,
): UseQueryResult<GetBusinessRulesResponse, Error> => {
    return useQuery<GetBusinessRulesResponse>({
        queryKey: ['rulesets', orgId, entityId, reload],
        queryFn: () => {
            return fetchBusinessRules(orgId, entityId)
        },
        refetchOnWindowFocus: false,
    })
}
